import React from "react";
// React Router
import { useHistory, useParams } from "react-router-dom";
// Styled Components
import styled from "styled-components";
// Components
import VerticalCard from "../../generic/VerticalCard";
import { categoriaMisiones } from "../../../contexto";

const CardMision = styled(VerticalCard).attrs(props => ({

  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`
-webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
filter: grayscale(${props => props.grayscale});

  :hover {
    box-shadow: 0 0px 6px #2a599f !important;
  }
`;

const MisionTarjeta = ({ content, ...props }) => {
  let history = useHistory();

  let { id_p } = useParams();

  let provinciaId = id_p ? id_p : '14';

  let defaultImg = "/images/logoSTJ.png";
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/provincias/${content.provinceId}/misiones/${content.id}/imagen` : `${process.env.REACT_APP_API_URL}/download/provincias/${provinciaId}/` ? `${process.env.REACT_APP_API_URL}/download/provincias/${provinciaId}/` : defaultImg;
  //`/images/provincias/${provinciaId}.png`;
  let text = content.type ? `${content.type}` + (!(content?.isCollaborative) ? " STJ" : ' en colaboración') : null;

  return (
    <>
      <CardMision
        onClick={(e) => {
          history.push(`mision/${content.id}`);
        }}
        cardImage={img}
        title={content.name}
        imgOnError={defaultImg}
        ciudad={`${content.country}, ${content.place}`}
        active={!content.endDate}
        {...props}
        body={[{ value: text, className: "text-center" }]}
      />
    </>
  );
};

export default MisionTarjeta;
